import {useTheme,Box,IconButton,Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Popup=({
    outterBackgroundColor='rgba(0,0,0,0.4)',
    popupWidth={xs:'100%',sm:'80%',md:'80%',lg:'80%'},
    windowBackgroundColor='background.paper',
    windowMaxHeight='90vh',
    children,
    onClose,
    footerComponent=null,
    headerComponent=null,
    zIndex=1300,
    title,
    titleBackgroundColor=null,
    titleColor=null
    })=>{
    
    const theme=useTheme();
    const primaryColor=theme.palette.primary.main;

    return (
        <Box
            sx={{
                position:'fixed',
                top:0,
                left:0,
                right:0,
                bottom:0,
                backgroundColor:outterBackgroundColor,
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                zIndex:zIndex,
                px:2,
                marginLeft:'0px !important'}}>
            <Box
                sx={{
                    width:popupWidth,
                    backgroundColor:windowBackgroundColor,
                    borderRadius:2,
                    boxShadow:24,
                    p:{xs:1.5,sm:1.5},
                    maxHeight:windowMaxHeight,
                    overflowY:'auto',}}>
                <Box
                    sx={{
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'space-between',
                        borderBottom:'1px solid',
                        borderColor:'divider',
                        color:titleColor||'white',
                        backgroundColor:titleBackgroundColor||primaryColor,
                        mb:2,
                        pl:2,}}>
                    <Typography variant="h6">{title}</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{color:titleColor||'white'}}/>
                    </IconButton>
                </Box>
                {headerComponent}
                {children}
                {footerComponent}
            </Box>
        </Box>
    );
};

export default Popup;